import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import PostCard from '../components/PostCard';
import '../styles/Home.css';

const HashtagPage = () => {
  const { hashtag } = useParams();
  // const dispatch = useDispatch();
  // const { user } = useSelector(state => state.auth);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchHashtagPosts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/hashtags/tag/${hashtag}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setPosts(response.data);
      } catch (error) {
        console.error('Error fetching hashtag posts:', error);
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    if (hashtag) fetchHashtagPosts();
  }, [hashtag, token]);

  const handleLike = async (postId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/posts/${postId}/like`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPosts(posts.map(p => p._id === postId ? response.data.post : p));
    } catch (err) {
      console.error('Error liking post:', err);
    }
  };

  const handleComment = async (postId, text) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/posts/${postId}/comment`,
        { text },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPosts(posts.map(p => p._id === postId ? response.data.post : p));
    } catch (err) {
      console.error('Error commenting on post:', err);
    }
  };

  return (
    <div className="home-container">
      <div className="home-layout">
        <div className="feed-section">
          <div style={{
            background: 'linear-gradient(135deg, #1a1a1a 0%, #121212 100%)',
            border: '1px solid #2a2a2a',
            padding: '2rem',
            borderRadius: '12px',
            marginBottom: '2rem',
            textAlign: 'center'
          }}>
            <h1 style={{ color: '#1dd1a1', marginBottom: '0.5rem' }}>#{hashtag}</h1>
            <p style={{ color: '#999' }}>
              {posts.length} {posts.length === 1 ? 'post' : 'posts'}
            </p>
          </div>

          {loading && <div className="loading">Loading posts...</div>}

          <div className="posts-list">
            {posts.length === 0 ? (
              <div style={{textAlign: 'center', padding: '2rem', color: '#666'}}>
                No posts found with this hashtag
              </div>
            ) : (
              posts.map(post => (
                <PostCard
                  key={post._id}
                  post={post}
                  onLike={handleLike}
                  onComment={handleComment}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HashtagPage;
